import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);
root.render(
	<GoogleOAuthProvider
		clientId={
			'37450922555-lsd1bmeclf7vr36qb0slqkh3f9970ogf.apps.googleusercontent.com'
		}
	>
		{/* <React.StrictMode> */}
		<App />
		{/* </React.StrictMode> */}
	</GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
